<script setup>
import {defineProps} from 'vue'

defineProps({
  count: {
    type: [Number, String],
    default: null,
  },
  background: {
    type: String,
    default: '#e5e7eb',
  },
  color: {
    type: String,
    default: '#6b7280',
  },
})
</script>

<template>
  <span
    class="count-badge d-inline-flex align-items-center custom fs-4 fw-semibold"
    :style="{backgroundColor: background, color}"
  >
    {{ count }}
  </span>
</template>

<style lang="scss" scoped>
.count-badge {
  height: toRem(17);
  padding: toRem(1) toRem(6);
  border-radius: toRem(10);
}
</style>
